define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/_base/underscore",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/def/Relationship",
	"csi/resolver",
	"csi/middleware/rollup/rollupService",
	"csi/store/_base",
	"csi/store/Names",
	"csi/utility/stringUtility",
	"csi/xml",
	"csi/xml/Query"
], function(array, declare, lang, csi, _, Action, ViewRef, Relationship, resolver, {evaluate}, csiStore, Names, {stringSubstitute}, xml, Query) {

	return declare(null, {
		TypeRelations: {
			"Season": "ParentSeason",
			"Category1": "Category1",
			"Category2": "Category2",
			"Collection": "Collection"
		},

		// String: specify attribute holding defaults (required for _resolveDefaults)
		defaultsAttribute: "",

		// String: specify attribute limiting to the defaults (required for _resolveDefaults)
		limitAttribute: "",

		/**
		 * Style store for the appropriate hierarchy level
		 *  @param level - current hierarchy level
		 *  @param paremtURL - url of the current node
		 */
		_getHierarchyStore(/*string*/ hierarchyLevel, /*cnl*/ currentNodeURL) {
			const STYLE = "Style";
			const q = (hierarchyLevel === STYLE) ? null : new Query().RefAttr(hierarchyLevel, xml.OP_EQUALS, currentNodeURL);
			let rel = lang.mixin(new Relationship(), {
				m_typeNode: STYLE,
				m_query: q
			})

			let storeOptions = csiStore.namesOptionsByRelationship(this.getContext(), rel);
			storeOptions.data = [csiStore.nameObject("")];
			storeOptions.action = lang.mixin(new Action(), {
				m_viewRef: lang.mixin(new ViewRef(), {
					m_id: "AllStyles",
					m_url: "centric://APPAREL/Views"
				}),
				m_fixedQuery: q
			});
			return new Names(storeOptions);
		},

		_resolveStyleType: function( /*Node*/ node) {
			// summary: return default style type if it is still available
			var defaults = this._resolveDefaults(node);
			if (defaults) {
				var config = resolver.m_cache.getPathNode(defaults, "Child:StyleType/Child:ProductionConfig", true);
				if (config && config.Available) {
					return defaults.StyleType;
				}
			}

			return null;
		},

		_resolveSourceAction: function( /*Node*/ node, /*Cache*/ cache, /*Boolean*/ bAll) {
			// summary: resolve select action for source
			let query;
			const actionFDDEnabled = this.m_action.m_id == "NewSupplierItemsFromSupplierFactories" || this.m_action.m_id == "NewFoodSupplierItemsFromFactories";
			if(actionFDDEnabled){
				query = new Query().Attr("Node Type", xml.OP_EQUALS, "SupplierFactory");
			} else {
				query = new Query().Attr("IsSupplier", xml.OP_EQUALS, true);
			}
			return this._resolveSourceActionInner(query, node, cache, bAll);
		},

		_resolveSourceActionInner: function( /*Query*/ query, /*Node*/ node, /*Cache*/ cache, /*Boolean*/ bAll) {
			// summary: resolve select action for source
			const actionFDDEnabled = this.m_action.m_id == "NewSupplierItemsFromSupplierFactories" || this.m_action.m_id == "NewFoodSupplierItemsFromFactories";
			const sourceId = actionFDDEnabled ? "SupplierFactories" : "Suppliers";
			let defaults = this._resolveDefaults(node, bAll);
			
			if (!bAll && !defaults) return null;

			if (defaults) {
				return lang.mixin(new Action(), {
					m_fixedQuery: query,
					m_viewRef: lang.mixin(new ViewRef(), {
						m_id: "SuppliersTable",
						m_url: defaults.$URL
					})
				});
			} else {
				let qry;
				if(!actionFDDEnabled){
					qry = query.Attr("State", xml.OP_NOT_EQUALS, "SourceState:Inactive")
				} else {
					qry = query.Attr("Active", xml.OP_EQUALS, true)
				}
				return lang.mixin(new Action(), {
					m_fixedQuery: qry,
					m_viewRef: lang.mixin(new ViewRef(), {
						m_id: sourceId,
						m_url: "centric://REFLECTION/INSTANCE/LibSourcing/SiteLibrary"
					})
				});
			}
		},

		_resolveDefaults: function( /*Node*/ node, /*Boolean*/ bAll, /*String?*/ defaultsAttribute) {
			// summary: traverse up parents until Default library is found - use resolver cache to make sure we have latest data
			var defaults;
			var value;

			defaultsAttribute = defaultsAttribute || this.defaultsAttribute;
			resolver.m_cache.put(node);

			while (node) {
				if (defaults = resolver.resolveNode(node.Defaults, true)) {
					// if limiting selections to defaults, then return defaults if searching for all (defaults will be only selections)
					if (defaults[this.limitAttribute]) {
						return bAll ? defaults : null;
					}

					// if not looking for all results and there are default items, then return defaults (defaults will be priority selections)
					value = defaults[defaultsAttribute];

					if (((typeof value === "string") && (value != csi.EMPTY_URL)) || ((value instanceof Array) && value.length)) {
						return bAll ? null : defaults;
					}
				}

				// otherwise, keep looking up hierarchy for defaults
				node = resolver.resolveParent(node);
			}

			return null;
		},

		_resolveFilters: function( /*csi.view.Widget*/ view, /*XMLNode[]*/ filters) {
			// summary: substitute correct attribute id in filter to access StructureItem
			var cache = view.cacheView;
			var node = view.getViewNode();
			if (!node) {
				return;
			}

			array.some(filters, function(f) {
				var id = f.getAttribute("Id");

				if (id === "${0}") {
					// evaluate filter value expression to get the node URL to filter by,
					// and substitute the attribute Id with the appropriate one for the type of node.
					var value = f.getAttribute("RValue");
					var url = evaluate(value, node, view.cacheView);

					// The RValue expression is currently only ever thisNode() or locationNode(), so
					// it should be available in the client caches.
					var valueNode = resolver.resolveNode(url, false, cache);
					var type = valueNode && valueNode.$Type;
					id = this.TypeRelations[type];

					if (id) {
						f.setAttribute("Id", id);
					} else {
						filters = _.without(filters, f);
					}

					return true;
				}

				return false;
			}, this);

			return filters;
		},

		_resolveViewFilter: function( /*csi.view.Widget*/ view, /*Relationship?*/ r) {
			// summary: resolve view relationship based on current context
			r = r || view.relRoot;

			if (r && r.m_filters) {
				r.m_filters = this._resolveFilters(view, r.m_filters);
			}
		},

		_resolveViewPath: function( /*csi.view.Widget*/ view, /*Relationship?*/ r) {
			// summary: substitute correct relationship in path to access StructureItem
			r = r || view.relRoot;

			var id = this._resolveViewRelation(view);
			var apaths = r ? r.m_addPaths : null;

			if (apaths && apaths.length) {
				apaths[0].m_path = stringSubstitute(apaths[0].m_path, [id]);
				// Make sure view is editable, unless specifically made read-only in the view preferences
				if (view.defView.bReadOnly === undefined) {
					view.defView.bReadOnly = false;
				}
			}
		},

		_resolveViewRelation: function( /*csi.view.Widget*/ view) {
			// summary: return appropriate relationship to current StructureItem - handle case where
			// node does not exist for custom view migration
			var node = view.getViewNode();
			var type = node ? node.$Type : "Season";
			return this.TypeRelations[type] || type;
		},

		_resolveShapeRelation: function( /*csi.view.Widget*/ view) {
			// summary: return appropriate relationship to current StructureItem - handle case where
			// node does not exist for custom view migration
			var node = view.getViewNode();
			var type = (node && node.$Type != "Season") ? node.$Type : "Seasons";
			return "Shape" + type;
		},

		_resolveThemeRelation: function( /*csi.view.Widget*/ view) {
			// summary: return appropriate relationship to current StructureItem - handle case where
			// node does not exist for custom view migration
			var node = view.getViewNode();
			// TA28273: For Season:  Themes with this season in their ThemeSeasons list
			var type = (node && node.$Type != "Season") ? node.$Type : "Seasons";
			return "Theme" + type;
		}
	});
});